import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';
import { ModalService } from '@features/modal/services/modal.service';
import { ActiveCampaignLeadMagnet } from '@generated/graphql';
import { LeadMagnetFormComponent } from '../lead-magnet-form/lead-magnet-form.component';
import { LeadMagnetWidgetComponent } from '../lead-magnet-widget/lead-magnet-widget.component';

@Component({
    selector: 'app-lead-magnet-active-campaign',
    templateUrl: './lead-magnet-active-campaign.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LeadMagnetWidgetComponent, LeadMagnetFormComponent],
})
export class LeadMagnetActiveCampaignComponent implements OnInit {
    @Input() entry: ActiveCampaignLeadMagnet;

    constructor(
        private modalService: ModalService,
        private eventTrackerService: EventTrackerService
    ) {}

    ngOnInit(): void {}

    cta() {
        this.eventTrackerService.trackEvent(
            ANALYTICS_EVENTS.LEAD_MAGNET_CLICK,
            {
                leadMagnet: this.entry.title,
                tag: this.entry.activeCampaignTag,
            }
        );
    }
}
